export const skeletonTypes = ['text', 'rect', 'circle', 'btn', 'input']
